import { Injectable } from '@angular/core';
import * as Constants from '@emi/shared/constants';
import { DynamicExchangeRate } from '@emi/shared/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService } from '../http.service';

@Injectable({
  providedIn: 'root',
})
export class ExchangeRatesService {
  constructor(private httpService: HttpService) { }

  public getCurrencyExchangeRates(currency: string): Observable<DynamicExchangeRate[]> {
    var selectedCurrency = currency === Constants.GlobalVariables.LOCAL_CURRENCY ? Constants.GlobalVariables.DEFAULT_CURRENCY : currency;

    return this.httpService.getHttp<Array<any>>(
      `${Constants.ServiceConstants.EXCHANGERATES}/${selectedCurrency}`,
      undefined)
      .pipe(
        map((exchangeRates: Array<any>) => {
          return [new DynamicExchangeRate(-1, currency, "", currency, "1"), ...exchangeRates.map((rate: any) => new DynamicExchangeRate(
            rate.id, rate.fromCurrencyName, rate.toCurrencyFullName, rate.toCurrencyName, rate.exchangeRateValue
          ))]
        }),
      );
  }
}
